module.exports = __webpack_public_path__ + "img/rectangle-vertical-history.ba6e03ee.svg";